import { render } from "./switch-number.html?vue&type=template&id=11ed5ff1&scoped=true&ts=true"
import script from "./switch-number.ts?vue&type=script&lang=ts"
export * from "./switch-number.ts?vue&type=script&lang=ts"

import "./switch-number.scss?vue&type=style&index=0&id=11ed5ff1&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ed5ff1"]])

export default __exports__